import {
  Box,
  Divider,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";

import { FileUploadResult } from "./useUploadSequoiaFiles";

interface SequoiaUploadResultProps {
  uploadResult: FileUploadResult;
}
export function SequoiaUploadResult({
  uploadResult,
}: SequoiaUploadResultProps) {
  return (
    <Grid container>
      <Grid item xs={6} pt={6}>
        <Typography variant="h3">Results</Typography>
      </Grid>
      <Box key={uploadResult.fileName}>
        <Typography variant="h4">{uploadResult.fileName}</Typography>
        <Typography variant="h5">
          Any errors shown below are critical processing errors, meaning these
          rows will not show up on the main Sequoia Statuses page and need to be
          fixed and re-uploaded.
        </Typography>
        <Divider sx={{ mt: 2 }} />
        {uploadResult.result.erroredRows.length > 0 && (
          <Table>
            <TableHead>
              <TableRow>
                {Object.keys(uploadResult.result.erroredRows[0]).map(
                  (property) => (
                    <TableCell key={property}>{property}</TableCell>
                  )
                )}
              </TableRow>
            </TableHead>
            <TableBody>
              {uploadResult.result.erroredRows.map((row) => (
                <TableRow
                  key={JSON.stringify(row)}
                  sx={{
                    "&:last-child td, &:last-child th": { border: 0 },
                  }}>
                  {Object.values(row).map((value) => (
                    <TableCell key={JSON.stringify(row) + value}>
                      {value}
                    </TableCell>
                  ))}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        )}
      </Box>
    </Grid>
  );
}
